import { WithdrawalAccountEntity } from 'api/types/entity';

import { WithdrawalAccountsFormType } from '../../forms/withdrawalAccountsForm';

export const parseWithdrawalAccountsInitialValue = (
  withdrawalAccounts?: WithdrawalAccountEntity[]
) => {
  const values: WithdrawalAccountsFormType['withdrawalAccounts'] =
    withdrawalAccounts?.map((v) => ({
      bankAddress: v.bankAddress,
      bankCountry: v.bankCountry,
      bankName: v.bankName,
      checkingAccount: v.checkingAccount,
      correspondentBankAccountNumber: v.correspondentBankAccountNumber ?? '',
      correspondentBankSwiftCode: v.correspondentBankSwiftCode ?? '',
      correspondentBankName: v.correspondentBankName ?? '',
      swiftCode: v.swiftCode,
      currency: { value: v.currency, label: v.currency },
      ownerConfirmationFiles: v.ownerConfirmationDocuments,
    })) || [];

  return values;
};
